module.exports = __webpack_public_path__ + "img/3.7bc3fb69.jpg";